<div class="row title-container">
	<div class="text-center" *ngIf="field.DisplayText">
		<h2>{{field.DisplayText}}</h2>
	</div>
	<div class="text-right" *ngIf="!field.disabled">
		<button class="btn btn-primary" (click)="createChild()">{{field.ButtonText}}</button>
	</div>
</div>

<div class="row container-item" *ngFor="let arrayFormField of arrayChilds; let i = index;">
	<div [class]="field.disabled ? 'col-md-12' : 'col-md-11'">
		<div class="row">
			<div class="col-xs-12 col-md-4 item-container" *ngFor="let formFieldChild of arrayFormField;">
				<cv-form-field [options]="{
			  					key: field.Name,
			  					path: field.path,
			  					index: i,
			  					childKey: formFieldChild.key
							}">
				</cv-form-field>
			</div>
		</div>
	</div>
	<div class="col-md-1 remove-form-container-button" *ngIf="!field.disabled">
		<button pButton icon="fa fa-trash" class="p-button-sm" (click)="deleteChild(i)"></button>
	</div>
</div>
